<template>
    <div class="bg-white p-4">
        <h2
            v-if="model.heading"
            class="mb-2 pb-2 border-b"
        >
            {{ model.heading }}
        </h2>

        <ul
            class="md:flex md:flex-wrap -mx-2 mb-4"
        >
            <li
                v-for="article in model.articles"
                :key="article.id"
                class="w-full md:w-1/3 p-2 group"
            >
                <div class="border group-hover:border-black group-hover:shadow p-2 relative h-full w-full">
                    <img
                        v-if="article.image"
                        :src="`${article.image}?width=494&height=315&mode=crop`"
                        class="mb-2 mx-auto"
                    />
                    <p
                        v-if="article.source"
                        class="text-gray-500 px-4 text-xs mb-1"
                    >
                        {{ article.source }}
                    </p>
                    <h3
                        class="text-base font-bold px-4 text-gray-800"
                        v-if="article.heading">
                        {{ article.heading }}
                    </h3>

                    <a
                        :href="article.url"
                        :title="article.heading"
                        class="absolute top-0 left-0 w-full h-full"
                    >
                        <span class="sr-only">
                            Gå til {{ article.heading }}
                        </span>
                    </a>

                </div>
            </li>
        </ul>

        <div class="text-center">
            <a
                :href="model.buttonUrl.value.url"
                class="btn text-lg py-4 px-8 btn-green w-auto inline-block"
            >
                {{ model.buttonText }}
            </a>


        </div>


    </div>
</template>

<script>
export default {
    props: ['model'],
    methods: {
        log(obj) {
            // console.log(obj);
        }
    }
};
</script>
